// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { fetchStrikes } from 'syft-acp-core/api/resources/admin/watchlists'
import { takeEveryApiCall } from './helpers'

export default function* root() {
  yield takeEveryApiCall('STRIKES_FETCH', fetchStrikes)
}
